import styled from 'styled-components'

const BackButtonStyle = styled.div`
	--backLinkWrapMarginTop: var(--sp5x);
	--backArrowMarginRight: var(--sp1-5x);
	--backArrowSizes: var(--sp3x);

	margin-top: var(--backLinkWrapMarginTop);

	&.disable {
		opacity: 50%;
		pointer-events: none;
	}

	.back-link {
		display: inline-flex;
		align-items: center;

		.back-arrow {
			transform: rotate(180deg);
			margin-right: var(--backArrowMarginRight);
			font-size: var(--backArrowSizes);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--backLinkWrapMarginTop: var(--sp4x);
		--backArrowMarginRight: var(--sp1x);
		--backArrowSizes: var(--sp2x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--backLinkWrapMarginTop: var(--sp4x);
		--backArrowMarginRight: var(--sp1x);
		--backArrowSizes: var(--sp2x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--backLinkWrapMarginTop: var(--sp4x);
		--backArrowMarginRight: var(--sp1x);
		--backArrowSizes: var(--sp2x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--backLinkWrapMarginTop: var(--sp4x);
		--backArrowMarginRight: var(--sp1x);
		--backArrowSizes: var(--sp2x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--backLinkWrapMarginTop: var(--sp3x);
		--backArrowMarginRight: var(--sp1x);
		--backArrowSizes: var(--sp2x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--backLinkWrapMarginTop: var(--sp3x);
		--backArrowMarginRight: var(--sp1x);
		--backArrowSizes: var(--sp2x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--backLinkWrapMarginTop: var(--sp3x);
		--backArrowMarginRight: var(--sp1-5x);
		--backArrowSizes: var(--sp1-5x);
	}
`

export default BackButtonStyle
